/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

require("@rails/ujs").start()
// require("turbolinks").start()
// require("@rails/activestorage").start()
// require("channels")
require('datatables.net-bs4')

import $ from 'jquery';
global.$ = jQuery;

import "core-js/stable"
import "regenerator-runtime/runtime"
import "../src/stylesheets/application.css";
import "../src/javascripts/jquery_nested_form"
import "../src/javascripts/select2.min"
import "../src/javascripts/app.min"
import "../src/javascripts/bootstrap.min"
import "nested-form";


$(".select2").select2();
// console.log('Hello World from Webpacker')
$(".select2tags").select2({
    tags: true
  });
$(function () {
    $('.dataTable').DataTable({
        "paging": true,
        "lengthChange": false,
        "searching": true,
        "ordering": true,
        "info": true,
        "autoWidth": false,
        "order": [],
        "language": {
            "search": "Cerca:",
            "emptyTable": "Nessun dato presente",
            "info": "Visualizzati da _START_ a _END_ di _TOTAL_ righe",
            "paginate": {
                "next": "Successiva",
                "previous": "Precedente"

            }
        }
    });

    $('.chosen-select').chosen
    allow_single_deselect: true
    no_results_text: 'No results matched'
    width: '200px'
});

$(document).on('nested:fieldAdded', function(event){
    console.log('Addded!');
});

$(document).on('nested:fieldRemoved', function(event){
    console.log('removed!');
});

$("#absence-form").ready(function(){
    if($("#absence_absence_type").val() == "Permesso") {
        $(".permit").show();
        $(".permit-data").removeAttr("disabled");
        $(".absence").hide();
        $(".absence-data").attr("disabled", "disabled");
    } else { 
        $(".permit").hide();
        $(".permit-data").attr("disabled", "disabled");
        $(".absence").show();
        $(".absence-data").removeAttr("disabled");
    }
    $("#absence_absence_type").on('change', function(){
        if($("#absence_absence_type").val() == "Permesso") {
            $(".permit").show();
            $(".permit-data").removeAttr("disabled");
            $(".absence").hide();
            $(".absence-data").attr("disabled", "disabled");
        } else { 
            $(".permit").hide();
            $(".permit-data").attr("disabled", "disabled");
            $(".absence").show();
            $(".absence-data").removeAttr("disabled");
        }
    })
});

$(document).ready(function(){   
    $("#delivery-type").change(function() {
        var sel = $("#delivery-type option:selected").text();
        if(sel == "Altro (specificare)") {
            $("#other-delivery-entry").show();
        } else {
            $("#other-delivery-entry").hide();
        }
    });

    $("#funding-source-select").change(function() {
        var sel = $("#funding-source-select option:selected").text();
        if(sel == "Altro (specificare)") {
            $("#other-funding-source-entry").show();
        } else {
            $("#other-funding-source-entry").hide();
        }
    });

    $("#tender-participation-particpation-type-select").change(function() {
        var sel = $("#tender-participation-particpation-type-select option:selected").text();
        if(sel == "Partenariato") {
            $("#other-participation-type-data").show();
        } else {
            $("#other-participation-type-data").hide();
        }
    });
    $("#tender-participation-status").change(function() {
        var sel = $("#tender-participation-status option:selected").text();
        if(sel == "apertura busta A") {
            $("#tender-participation-opening-date").show();
        } else {
            $("#tender-participation-opening-date").hide();
        }
    });
});

$.ajaxSetup({  
  'beforeSend': function (xhr) {xhr.setRequestHeader('Content-Type', 'application/javascript');}  
});

function setPrice(element){
    $.ajax({
        url: "/admin/envelope_cs/security_price",
        type: "GET",
        data: 'security_id=' + $(element).val()
      }).done(function(msg) {
        $(element).parent().next().html(msg);
      }).fail(function() {
        $(element).parent().next().html("");
      })
    
}

$("#requests-field").on('change', function(){
    var fd = new FormData(document.getElementById('import-form'));
    $.ajax({
        url: "/admin/envelope_as/import_requests",
        type: "POST",
        data: fd,
        processData: false,
        contentType: false,
        beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))}

      }).done(function(msg) {
        //console.log(msg);
        //$("#requests-table").html(msg);
      }).fail(function() {console.log(":(")})
});

$("#economic-plan-field").on('change', function(){
    var fd = new FormData(document.getElementById('envelope-c-form'));
    fd.append("envelope_id", $(this).attr('envelope_id'));
    fd.delete("_method");
    $.ajax({
        url: "/admin/envelope_cs/import_plans",
        type: "POST",
        data: fd,
        processData: false,
        contentType: false,
        beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))}

      }).done(function(msg) {
      }).fail(function() {console.log(":(")})
});

/*$("#employees-field").on('change', function(){
    var fd = new FormData(document.getElementById('import-employees'));
    $.ajax({
        url: "/admin/employees/import_employees",
        type: "POST",
        data: fd,
        processData: false,
        contentType: false,
        beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))}

      }).done(function(msg) {
        //console.log(msg);
        //$("#requests-table").html(msg);
      }).fail(function() {console.log(":(")})
});*/


function setEmployeeTasks(element) {
    $.ajax({
        url: '/admin/awarded_activities/'+$('#presence_awarded_activity_id').val()+'/presences/employee_tasks',
        type: "GET",
        data: 'employee_id=' + $(element).val()
    }).done(function(msg) {
        $("#tasks").html(msg);
    }).fail(function() {
        //$(element).parent().next().html("");
    })
}

window.setPrice = setPrice;
window.setEmployeeTasks = setEmployeeTasks;